export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/websiteLogoAr.238b3a7c.svg","height":1226,"width":4096,"blurWidth":0,"blurHeight":0};